import React, { useState, useEffect } from 'react';
import { useFilterContext } from './FilterContext.jsx';
import { motion, AnimatePresence } from 'framer-motion';
import { Filter as FilterIcon, Calendar, MapPin, X } from 'lucide-react';
import { ugandaDistricts } from './Districts.jsx';

export const Filter = () => {
    const { filterName, setFilterName, eventDate, setEventDate } = useFilterContext();
    const [isOpen, setIsOpen] = useState(false);

    const dateOptions = [
        { value: 'all', label: 'All Dates' },
        { value: 'today', label: 'Today' },
        { value: 'tomorrow', label: 'Tomorrow' },
        { value: 'this-week', label: 'This Week' },
        { value: 'this-month', label: 'This Month' },
        { value: 'next-month', label: 'Next Month' }
    ];

    const handleFilterChange = (type, value) => {
        if (type === 'location') {
            setFilterName(value);
        } else if (type === 'date') {
            setEventDate(value);
        }
    };

    const clearFilters = () => {
        setFilterName('');
        setEventDate('all');
    };

    return (
        <div className="flex-1">
            <div className="flex items-center justify-between mb-2">
                <button
                    onClick={() => setIsOpen(!isOpen)}
                    className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors duration-200 text-sm"
                >
                    <FilterIcon className="w-4 h-4" />
                    <span className="font-medium">Filters</span>
                </button>
                
                {(filterName || eventDate !== 'all') && (
                    <button
                        onClick={clearFilters}
                        className="text-xs text-gray-500 hover:text-gray-700 transition-colors duration-200"
                    >
                        Clear
                    </button>
                )}
            </div>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3 }}
                        className="bg-white border border-gray-200 rounded-lg p-3 mb-2"
                    >
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {/* Location Filter */}
                            <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                    <MapPin className="w-3 h-3 inline mr-1" />
                                    Location
                                </label>
                                <select
                                    value={filterName}
                                    onChange={(e) => handleFilterChange('location', e.target.value)}
                                    className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-orange-400 focus:border-transparent transition-all duration-200"
                                >
                                    <option value="">All Locations</option>
                                    {ugandaDistricts.map((district, index) => (
                                        <option key={index} value={district.name}>
                                            {district.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Date Filter */}
                            <div>
                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                    <Calendar className="w-3 h-3 inline mr-1" />
                                    Date
                                </label>
                                <select
                                    value={eventDate}
                                    onChange={(e) => handleFilterChange('date', e.target.value)}
                                    className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-orange-400 focus:border-transparent transition-all duration-200"
                                >
                                    {dateOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}; 